module.exports = __webpack_public_path__ + "node_modules/icheck/skins/square/blue.png?96f8a905";